import _ from "lodash";
import { MediaFile } from "src/types/media";

export const validateBannerBackground = (settings: any) => {
  if (!settings) return settings;

  const background = _.get(settings, "banner.background");
  if (typeof background !== "string") {
    return _.omit(settings, "banner.background");
  }

  return settings;
};

export const convertBannerToBase64 = async (banner?: MediaFile | string): Promise<string | undefined> => {
  if (!banner) return undefined;

  const toBase64 = (blob: Blob) => 
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

  // If it's already a string, check if it's a URL or base64
  if (typeof banner === 'string') {
    if (banner.startsWith('data:')) return banner;
    const response = await fetch(banner);
    const blob = await response.blob();
    return toBase64(blob);
  }

  const mediaFile = banner as MediaFile;

  // If it's a local file
  if (mediaFile.file) {
    return toBase64(mediaFile.file);
  }

  // If it's uploaded to S3
  if (mediaFile.full) {
    const response = await fetch(mediaFile.full);
    const blob = await response.blob();

    if (mediaFile.type === 'video') {
      // Convert video blob to base64 manually
      const arrayBuffer = await blob.arrayBuffer();
      const base64 = btoa(
        new Uint8Array(arrayBuffer)
          .reduce((data, byte) => data + String.fromCharCode(byte), '')
      );
      return `data:video/mp4;base64,${base64}`;
    }

    // Default to image conversion
    return toBase64(blob);
  }

  return undefined;
};


export const validateLogo = (logo: any) => {
  if (logo && typeof logo !== "string") return null;
  return logo;
};